import React, {useState} from 'react';
import ReactTableBase from "../Table/ReactTableBase";
import {Link} from "react-router-dom";
import {
    getUtilisateurRoleIcon,
    getUtilisateurRoleLabel,
    getUtilisateurStatusIcon,
    parseUtilisateurStatus
} from "../../services/UserService";
import renderCellRating from "../Table/RenderCellRating";
import {icons} from "../Icons/icons";
import {exportToCsv} from "../../services/FileService";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload} from "@fortawesome/free-solid-svg-icons";
import Routing from "../../services/routing";
import TableSearch from "../Table/TableSearch";
import {filteredDataTabSearch} from "../../services/UtilsService";
import DateService from "../../services/DateService";

const UsersStatsTable = ({ users, serverSideSorting = false, onSortChange, initialSortBy }) => {
    const data = React.useMemo(() => users, [users]);
    const hasEnterprise = users.some(user => user.entreprise);
    const [searchQuery, setSearchQuery] = useState("");
    const handleSearch = (event) => { setSearchQuery(event.target.value);};

    const renderCellPlaces = ({ row, value }) => {
        return `${ value } / ${row.original.participantsMax}`;
    }

    const renderCellId = ({ row }) => {
        return (
            <div>
                {row.original.id}
            </div>
        );
    }

    const renderCellType = ({ row }) => {
        return (
            <div style={{
                color: row.original.type.clr_font,
                backgroundColor: row.original.type.clr_bg,
                padding: "5px 10px",
            }}>
                <Link to={Routing.generate({route: Routing.routes.seance, params: { id: row.original.id }})}>
                    {row.original.type.label}
                </Link>
            </div>
        );
    }

    const renderCellDate = ({ value }) => {
        return (
            <div>
                {value ? DateService.formatDate(value) : ""}
            </div>
        );
    }

    const renderCellDateNaiss = ({ value }) => {
        return (
            <div>
                {value ? DateService.formatFrenchDateWithoutTime(value) : ""}
            </div>
        );
    }

    const renderCellRoles = ({ value }) => {
        return (
            <div>
                {value.map((role, index) => (
                    <div key={index}>
                        {getUtilisateurRoleLabel(role)}
                    </div>
                ))}
            </div>
        );
    }

    const renderCellStatus = ({ value }) => {
        return (
            <div>
                { getUtilisateurStatusIcon(value) }
                { parseUtilisateurStatus(value) }
            </div>
        );
    }

    const renderCellEntreprise = ({ row }) => {
        if (!row.original.entreprise) return (<div></div>);

        return (
            <div>
                { row.original.entreprise ? row.original.entreprise.nom : "" }
            </div>
        );
    }

    const renderCellNom = ({ row, value }) => {
        return (
            <div>
                { value }
            </div>
        );
    }

    const renderCellPrenom = ({ row, value }) => {
        return (
            <div>
                { value }
            </div>
        );
    }

    const renderCellCivilite = ({ value }) => {
        if (!value || !value.civIcon || !value.civColor) return null;

        const Icon = icons[value.civIcon];

        return (
            <div style={{ backgroundColor: "transparent"}} >
                {Icon ? <Icon style={{ fill: value.civColor, height: "24px", width: "24px" }} /> : null}
            </div>
        );
    }

    const columns = [
        {
            Header: "Nom",
            accessor: "nom",
            Cell: renderCellNom,
        },
        {
            Header: "Prénom",
            accessor: "prenom",
            Cell: renderCellPrenom,
        },
        {
            Header: "Civilité",
            accessor: "civilite",
            Cell: renderCellCivilite,
        },
        /*
        {
            Header: 'Statut',
            accessor: 'status',
            Cell: renderCellStatus,
        },
        */
        {
            Header: 'Date de naissance',
            accessor: 'date_naissance',
            Cell: renderCellDateNaiss,
        },
        {
            Header: 'Date import',
            accessor: 'date_import',
            Cell: renderCellDate,
        },
        {
            Header: 'Date création compte',
            accessor: 'date_creation_compte',
            Cell: renderCellDate,
        },
        {
            Header: 'Nombre de réservations',
            accessor: 'nb_inscriptions',
        },
        {
            Header: 'Nombre de listes d\'attente',
            accessor: 'nb_file_attente',
        },
        {
            Header: 'Nombre de séances réalisées',
            accessor: 'nb_participations',
        },
        {
            Header: 'Nombre d\'annulations',
            accessor: 'nb_annulations',
        },
        {
            Header: 'Pas venu',
            accessor: 'nb_pas_venu',
        },
        {
            Header: "Satisfaction Globale",
            accessor: "satisfaction_globale",
            Cell: renderCellRating,
        },
    ];

    if (hasEnterprise) {
        columns.unshift({ // Ajout d'une colonne en début de tableau
            Header: 'Entreprise',
            accessor: 'entreprise',
            Cell: renderCellEntreprise,
        });
    }

    const handleDownloadCSV = () => {
        if (hasEnterprise) {
            users.forEach(user => {
                user.entreprise = user.entreprise ? user.entreprise.nom : "";
            });
        }
        exportToCsv("users_stats.csv", users, columns);
    };

    const filteredData = filteredDataTabSearch(users, columns, searchQuery);


    return (
        <>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", margin: "12px 0 12px 0", padding: "0 8px 0 0"}}>
                <TableSearch onSearch={handleSearch} value={searchQuery} />

                <button className={"btn"} style={{
                    backgroundColor: "#e7f1e6",
                    border: "2px solid var(--clr-accent)",
                    height: "fit-content",

                }} onClick={handleDownloadCSV} title={"Télécharger le tableau"}>
                    <FontAwesomeIcon icon={faDownload}/>
                </button>
            </div>

            <ReactTableBase dataSource={filteredData} columnsData={columns} serverSideSorting={serverSideSorting}
                            initialSortBy={initialSortBy} onSortChange={onSortChange}/>
        </>
    );
};

export default UsersStatsTable;
